import { ILanguageOption } from "../interfaces/language-options.interface";

export const AppLanguageOptions: ILanguageOption[] = [
  { label: "DE", code: "de" },
  { label: "EN", code: "en" },
];
